import React, { useState } from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const InteractiveLink = () => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div className="w-full max-w-3xl mx-auto my-8">
      <Link to={"/SelectStreanWithNAE"} className="block"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className={`bg-gradient-to-br ${isHovered ? 'from-purple-600 to-blue-500' : 'from-blue-500 to-purple-600'} rounded-xl p-1 shadow-lg transform transition-all duration-300 ${isHovered ? 'scale-105 shadow-xl' : ''}`}>
          <div className="bg-white dark:bg-gray-900 rounded-lg p-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className={`p-2 rounded-full ${isHovered ? 'bg-purple-100 dark:bg-purple-900' : 'bg-blue-100 dark:bg-blue-900'}`}>
                  <Sparkles className={`w-6 h-6 ${isHovered ? 'text-purple-600 dark:text-purple-400' : 'text-blue-600 dark:text-blue-400'}`} />
                </div>
                <h3 className="text-xl font-bold">Discover Your Stream</h3>
              </div>
              <ArrowRight className={`w-5 h-5 transform transition-all duration-300 ${isHovered ? 'translate-x-1' : ''}`} />
            </div>
            
            <p className="mt-4 text-gray-600 dark:text-gray-300">
              Find the perfect stream that matches your interests and skills. Our advanced selection tool helps you navigate your educational journey with ease.
            </p>
            
            <div className="mt-6 flex flex-wrap gap-2">
              <span className="px-3 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded-full text-sm">Science</span>
              <span className="px-3 py-1 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded-full text-sm">Commerce</span>
              <span className="px-3 py-1 bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200 rounded-full text-sm">Arts</span>
              <span className="px-3 py-1 bg-amber-100 dark:bg-amber-900 text-amber-800 dark:text-amber-200 rounded-full text-sm">Vocational</span>
            </div>
            
            <button className={`mt-6 w-full py-3 rounded-lg font-medium text-white transition-all duration-300 ${isHovered ? 'bg-purple-600 shadow-md shadow-purple-200 dark:shadow-purple-900/30' : 'bg-blue-600 shadow shadow-blue-200 dark:shadow-blue-900/30'}`}>
              Select Your Stream Now
            </button>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default InteractiveLink;